module.exports = __webpack_public_path__ + "static/media/photo-13.041c1269.jpg";